module.exports = __webpack_public_path__ + "static/media/cross.389e6ad5.svg";